// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form_description[data-v-ab0c606c]{font-size:12px;color:#aaa;max-width:700px}.pods_on_node[data-v-ab0c606c]{padding:20px;margin:0;min-height:200px}.drain_cmd[data-v-ab0c606c],.pods_on_node[data-v-ab0c606c]{background-color:var(--el-text-color-primary);color:var(--el-color-white)}.drain_cmd[data-v-ab0c606c]{padding:10px 20px;font-weight:700}", ""]);
// Exports
module.exports = exports;
